
import { ContactListScreenNavigationProps } from "./types"
import React from "react"
import ContactList from "./contact-list-screen"
import { PageRoot } from "~screens/page-root"



const ContactListScreen: React.FC<ContactListScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <ContactList />
    </PageRoot>
  )
}

export default ContactListScreen
